import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/affiliate'),
      component: () => import('../SettingsWrapper.vue'),
      props: {
        headerTitle: 'BILLING_SETTINGS.AFFILIATE.PAGE_TITLE',
        icon: 'megaphone',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'affiliate_settings_index',
          component: () => import('./Index.vue'),
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
      ],
    },
  ],
};
